import { HttpClient } from '@angular/common/http';
import { BaseProvider } from './base-provider';
import { GlobalsService } from './globals.service';
import { HttpHelperService } from './http-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
import * as i2 from "./http-helper.service";
import * as i3 from "@angular/common/http";
export class PhotoSideBySideService extends BaseProvider {
    constructor(globals, httpHelper, http) {
        super();
        this.globals = globals;
        this.httpHelper = httpHelper;
        this.http = http;
        this.baseUrl = 'photoSideBySide';
    }
    getPhotoSideBySide(userProcessId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/' + userProcessId;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }
}
PhotoSideBySideService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PhotoSideBySideService_Factory() { return new PhotoSideBySideService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpHelperService), i0.ɵɵinject(i3.HttpClient)); }, token: PhotoSideBySideService, providedIn: "root" });
